import React from "react";
import PropTypes from "prop-types";
import { Popup } from "components/Popup/popup";
import Form from "components/react-validation/components/form";
import { Dropdown } from "components/Dropdown/Dropdown";

class OpenPendingPopup extends React.Component {
  static propTypes = {
    onSaveOpenPendingPopup: PropTypes.func,
    onCancelOpenPendingPopup: PropTypes.func,
    subcontractorList: PropTypes.array,
    userList: PropTypes.array,
    workOrderTypeList: PropTypes.array,
    onFetchUser: PropTypes.func,
    onFetchSubcontractor: PropTypes.func,
    onFetchWOT: PropTypes.func,
    rfsInformation: PropTypes.object,
    woInformation: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      subcontractor: null,
      user: {
        value: props.rfsInformation.managedByUser.id,
        text: props.rfsInformation.managedByUser.displayName,
        extensionValue: { email: props.rfsInformation.managedByUser.email },
        selected: false,
      },
      isFetchedUser: false,
      isModeAssignSub: true,
      isLoadingSubcontractor: false,
      isLoadingUser: false,
      wot: null,
      isLoadingWorkOrderType: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.subcontractorList) {
      this.setState({ isLoadingSubcontractor: false });
    }
    if (nextProps.userList) {
      this.setState({ isLoadingUser: false, isFetchedUser: true });
    }
    if (nextProps.workOrderTypeList) {
      this.setState({ isLoadingWorkOrderType: false });
    }
  }

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value,
    });
  };

  onFetchUser = () => {
    this.setState({ isLoadingUser: true });
    this.props.onFetchUser();
  };

  onFetchSubcontractor = () => {
    this.setState({ isLoadingSubcontractor: true });
    this.props.onFetchSubcontractor();
  };

  onFetchWOT = () => {
    this.setState({ isLoadingWorkOrderType: true });
    this.props.onFetchWOT();
  };

  handleModeAssign = (mode) => {
    if (mode === "sub") {
      this.setState({ isModeAssignSub: true });
    } else {
      this.setState({ isModeAssignSub: false });
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { subcontractor, user } = this.state;
    let param = {};
    if (
      this.props.woInformation.subcontractorProfile ||
      this.props.woInformation.assignedUser
    ) {
      param["subcontractorId"] = this.props.woInformation.subcontractorProfile
        ? this.props.woInformation.subcontractorProfile.subcontractorId
        : null;
      param["assignedUserId"] = this.props.woInformation.assignedUser
        ? this.props.woInformation.assignedUser.id
        : null;
    } else {
      if (this.state.isModeAssignSub) {
        param["subcontractorId"] = subcontractor.value;
        param["assignedUserId"] = null;
      } else {
        param["subcontractorId"] = null;
        param["assignedUserId"] = user.value;
      }
    }
    param["workOrderTypeId"] = this.props.woInformation.workOrderType
      ? this.props.woInformation.workOrderType.id
      : this.state.wot.value;
    this.props.onSaveOpenPendingPopup(param);
  };

  render() {
    let disabled = true;
    const popupStyle = {
      width: 400,
      left: 160,
    };
    if (
      this.props.woInformation.workOrderType &&
      !this.props.woInformation.subcontractorProfile &&
      !this.props.woInformation.assignedUser
    ) {
      popupStyle["top"] = -250;
      disabled = this.state.isModeAssignSub
        ? !this.state.subcontractor
        : !this.state.user;
    } else if (
      !this.props.woInformation.workOrderType &&
      !this.props.woInformation.subcontractorProfile &&
      !this.props.woInformation.assignedUser
    ) {
      popupStyle["top"] = -360;
      disabled =
        (this.state.isModeAssignSub
          ? !this.state.subcontractor
          : !this.state.user) || !this.state.wot;
    } else {
      popupStyle["top"] = -260;
      disabled = !this.state.wot;
    }

    return (
      <Popup
        ref={(ref) => {
          this.resolvePopup = ref;
        }}
        isHasFaded={true}
        styles={popupStyle}
      >
        <Form
          className="form-horizontal"
          ref={(ref) => {
            this.form = ref;
          }}
          onSubmit={this.onSubmit}
        >
          <div style={{ paddingTop: 10, paddingBottom: 10 }}>
            <div className="form-group">
              <div className="col-sm-12 col-xs-12" style={{ marginBottom: 0 }}>
                <label className="col-xs-12">
                  To open a work order, you must specify the field(s) below.
                </label>
              </div>
            </div>
            {!this.props.woInformation.assignedUser &&
              !this.props.woInformation.subcontractorProfile && (
                <div className="form-group">
                  <div className="col-sm-12 col-xs-12">
                    <div className="col-xs-12" style={{ marginBottom: 5 }}>
                      Assigned to
                      <div
                        className="btn-group btn-group-sm wo-assign-btn-group"
                        role="group"
                      >
                        <button
                          type="button"
                          className={
                            "btn btn-secondary " +
                            (this.state.isModeAssignSub ? "active" : "")
                          }
                          onClick={() => {
                            this.handleModeAssign("sub");
                          }}
                        >
                          subcontractor
                        </button>
                        <button
                          type="button"
                          className={
                            "btn btn-secondary " +
                            (!this.state.isModeAssignSub ? "active" : "")
                          }
                          onClick={() => {
                            this.handleModeAssign("user");
                          }}
                        >
                          internal user
                        </button>
                      </div>
                    </div>
                    <div className="col-xs-12">
                      {this.state.isModeAssignSub ? (
                        <Dropdown
                          onChange={(ref) => {
                            this.onSelectChange(ref, "subcontractor");
                          }}
                          filter={true}
                          className="filestring-dropdown filter-dropdown"
                          onRemote={this.onFetchSubcontractor}
                          options={this.props.subcontractorList}
                          optionLabel="text"
                          value={this.state.subcontractor}
                          loading={this.state.isLoadingSubcontractor}
                          name="subcontractor"
                          placeholder="--Select a trade first"
                          style={{
                            width: "100%",
                            paddingLeft: 10,
                            paddingRight: 10,
                            margin: 0,
                          }}
                        />
                      ) : (
                        <Dropdown
                          onChange={(ref) => {
                            this.onSelectChange(ref, "user");
                          }}
                          filter={true}
                          className="filestring-dropdown filter-dropdown"
                          onRemote={this.onFetchUser}
                          options={
                            this.props.userList.length
                              ? this.props.userList
                              : [{ ...this.state.user }]
                          }
                          loading={this.state.isLoadingUser}
                          optionLabel="text"
                          value={this.state.user}
                          name="user"
                          placeholder="--Select a user"
                          style={{
                            width: "100%",
                            paddingLeft: 10,
                            paddingRight: 10,
                            margin: 0,
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}
            {!this.props.woInformation.workOrderType && (
              <div className="form-group">
                <div className="col-sm-12 col-xs-12">
                  <label className="col-sm-12 control-label form-siteone-label">
                    Work order type
                  </label>
                  <div className="col-sm-12">
                    <Dropdown
                      onChange={(ref) => {
                        this.onSelectChange(ref, "wot");
                      }}
                      className="filestring-dropdown filter-dropdown"
                      onRemote={this.onFetchWOT}
                      options={this.props.workOrderTypeList}
                      loading={this.state.isLoadingWorkOrderType}
                      optionLabel="text"
                      value={this.state.wot}
                      name="workOrderType"
                      placeholder="--Please select"
                      style={{
                        width: "100%",
                        paddingLeft: 10,
                        paddingRight: 10,
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            <ul
              className="wo-popup-bottom-btn"
              style={{ paddingLeft: 5, borderTop: 0, marginTop: -10 }}
            >
              <li>
                <button
                  className="btn btn-primary btn-siteone-default btn-wo-edit"
                  onClick={this.props.onCancelOpenPendingPopup}
                >
                  Cancel
                </button>
              </li>
              <li>
                <button
                  className="btn btn-primary btn-siteone"
                  disabled={disabled}
                >
                  Save & Send
                </button>
              </li>
            </ul>
          </div>
        </Form>
      </Popup>
    );
  }
}

export default OpenPendingPopup;



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/OpenPendingPopup.js